export class FilterBudgetCalculation {
    divisionId!: number;
    areaId!: number;
    percentageIncrease!: number;
}